import React from 'react';
import PropTypes from 'prop-types';
import { wrapDisplayName } from 'recompose';
import { connect } from 'react-redux';
import _ from 'lodash';
import fp from 'lodash/fp';
import {
  getValue,
  getDiscountValue,
  toPercentage,
} from '@deerplusofficial/pos-helper';
import { withQueryTax } from '../model/Queries';
import withSubtotal from './withSubtotal';

export function getItemDiscount(item, id) {
  const {
    retail_price,
    unit_price,
    quantity,
    discount: { formattedValue, type },
  } = item;

  return getDiscountValue({
    quantity,
    formattedValue,
    isDiscountPlan: type === 1,
    price: unit_price || retail_price,
  });
}

export default () => Component =>
  fp.compose(
    withQueryTax(),
    withSubtotal(),
    connect(({ cart, order }, { getSubtotal }) => {
      const { discount: orderDiscount } = order;
      const { type, formattedValue, name } = orderDiscount;

      if (_.size(orderDiscount) === 0)
        return {
          cart,
          order,
          subtotal: getSubtotal(),
        };

      const discount = getValue(formattedValue);
      const subtotal = getSubtotal(true);
      const discountValue =
        discount % 1 !== 0 ? _.round(discount * subtotal) : discount;

      return {
        cart,
        order,
        subtotal: getSubtotal(),
        orderDiscount: {
          discountValue,
          name: type === 0 ? '手動輸入折扣' : name,
        },
      };
    })
  )(
    class extends React.PureComponent {
      static displayName = wrapDisplayName(Component, 'WithCartProps');

      static propTypes = {
        subtotal: PropTypes.number,
        tax: PropTypes.shape({
          rate: PropTypes.number,
          type: PropTypes.string,
          name: PropTypes.string,
        }),
        cart: PropTypes.shape({
          active: PropTypes.bool,
          items: PropTypes.shape({
            [PropTypes.string]: PropTypes.shape({
              quantity: PropTypes.number,
              retail_price: PropTypes.number,
              unit_price: PropTypes.number,
            }),
          }),
        }),
        order: PropTypes.shape({
          customPrice: PropTypes.number,
        }),
        orderDiscount: PropTypes.shape({
          discountValue: PropTypes.number,
        }),
      };

      static defaultProps = {
        subtotal: 0,
        tax: {},
        cart: {},
        orderDiscount: {},
        order: {},
      };

      get tax() {
        const {
          tax: { name, rate, type },
        } = this.props;
        const formattedTaxRate = toPercentage(rate);

        switch (type) {
          case 'included':
            return {
              type,
              name: `含${name}(${formattedTaxRate})`,
              value: _.round((this.totalPrice * rate) / (1 + rate)),
            };
          case 'excluded':
            return {
              type,
              name: `${name}(${formattedTaxRate})`,
              value: _.round(this.totalPrice * rate),
            };
          default:
            return { type, name: `免稅`, value: 0 };
        }
      }

      get totalPrice() {
        const { subtotal } = this.props;
        return subtotal > this.totalDiscount
          ? subtotal - this.totalDiscount
          : 0;
      }

      get totalDiscount() {
        const { cart, orderDiscount } = this.props;
        const itemDiscounts = _.map(cart.items, getItemDiscount);
        return _.sum([orderDiscount.discountValue, ...itemDiscounts]) || 0;
      }

      get checkoutPrice() {
        const { type, value } = this.tax;
        return type === 'excluded' ? this.totalPrice + value : this.totalPrice;
      }

      render() {
        return (
          <Component
            {...this.props}
            totalPrice={this.totalPrice}
            totalDiscount={this.totalDiscount}
            checkoutPrice={this.checkoutPrice}
            tax={this.tax}
          />
        );
      }
    }
  );



// WEBPACK FOOTER //
// ./src/assist/withCartProps.js